import logo from "../assets/images/logo.png";
import React, { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Divider } from "primereact/divider";
import { useNavigate } from "react-router-dom";
import { AxiosError } from "axios";
import { errorHandler } from "../utils/HelperFunctions";
import "../assets/css/login.css";
import cryptoHelper from "../libs/password";
import useToast from "../components/common/useToast";
import apiFunctions from "../services/api-service";
import {
  EyeIcon,
  EyeSlashIcon
} from "@heroicons/react/24/outline";
import { useDispatch } from "react-redux";
import { login } from "../redux/features/authSlice";

const LoginPage: React.FC = () => {
  const { showToast }: any = useToast();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showPassword, setShowPassword] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Enter valid username address")
      .required("Username is required!"),
    password: Yup.string().min(8).max(12).required("Password is required!"),
  });

  const initialValue = {
    email: "",
    password: "",
  };

  const loginSubmit = async (payload: any) => {
    await apiFunctions
      .post(`/superadmin/login`, payload)
      .then(async (response) => {
        if (response && response.data && response.data.success) {
          const timeout = String(new Date().setMinutes(new Date().getMinutes() + 15));
          const token = response.data.token; // Normally from API response

          await dispatch(login({ token, timeout }));
          navigate("/admin/");
        } else {
          showToast({
            severity: "error",
            summary: "Error",
            detail: response.data.message,
            life: 3000,
          });
        }
      })
      .catch((err: AxiosError) => {
        errorHandler(err);
      });
  };

  const handleShowPassword = () => {
    if (showPassword) {
      setShowPassword(false);
    } else {
      setShowPassword(true);
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: validationSchema,

    onSubmit: async (values: any) => {
      let pass: any = cryptoHelper.generatePassword(values.password);
      let encodedPassword = encodeURIComponent(pass);
      let payload = {
        username: values.email,
        password: encodedPassword,
      };
      loginSubmit(payload);
    },
  });

  return (
    <form action="submit" onSubmit={formik.handleSubmit}>
      <div className="grid main-container justify-center items-center">
        <div className="grid form-container">
          <div className="login-logo">
            <img src={logo} alt="sagar samaj" className="mainlogo" />
          </div>
          <Divider align="center">
            <div className="inline-flex items-center">
              Your Social Campaigns
            </div>
          </Divider>
          <div className="form-inputs">
            <div className="mt-3">
              <label className="form-label" htmlFor="email">
                Username
              </label>
              <InputText
                className={`form-control ${formik.touched.email && formik.errors.email ? "p-invalid" : ""
                  }`}
                id="email"
                name="email"
                onChange={formik.handleChange}
                value={formik.values.email}
              />
              {formik.touched.email && formik.errors.email && (
                <span id="email-help" className="p-error text-left mt-2">
                  {formik.errors.email as string}
                </span>
              )}
            </div>
            <div className="field mt-3">
              <label className="form-label mb-1" htmlFor="password">
                Password
              </label>
              <div
                className={`p-inputgroup ${formik.touched.password && formik.errors.password
                  ? "p-invalid"
                  : ""
                  }`}
              >
                <InputText
                  className={`form-control`}
                  type={`${showPassword ? "text" : "password"}`}
                  id="password"
                  name="password"
                  onChange={formik.handleChange}
                  value={formik.values.password}
                />
                <span className={`p-inputgroup-addon setStyle`}>
                  {showPassword ? (
                    <EyeSlashIcon
                      className="cursor-pointer w-5 h-5"
                      onClick={() => {
                        handleShowPassword();
                      }}
                    />
                  ) : (
                    <EyeIcon
                      className="cursor-pointer w-5 h-5"
                      onClick={() => {
                        handleShowPassword();
                      }}
                    />
                  )}
                </span>
              </div>
              {formik.touched.password && formik.errors.password && (
                <span id="password-help" className="p-error text-left mt-2">
                  {formik.errors.password as string}
                </span>
              )}
            </div>
            {/* <div className="grid grid-cols-12 gap-4 mt-4">
              <div className="col-span-6">
                <div className="flex items-center">
                  <Checkbox
                    inputId="rememberme"
                    name="pizza"
                    value="Cheese"
                    onChange={onRememberMeChange}
                    checked={rememberMe}
                  />
                  <label htmlFor="rememberme" className="ml-2 form-label">
                    Remember Me
                  </label>
                </div>
              </div>
              <div
                className="col-span-6 form-label justify-end cursor-pointer"
                onClick={handleForgetPassword}
              >
                Forget Password?
              </div>
            </div> */}
            <div className="field mt-5 mb-4">
              <Button
                label="LOGIN"
                className="prime-button btn-login"
                type="submit"
              ></Button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default LoginPage;
